export const API_KEY = "d035c82a4e9c82e90cf592ee503fbfb9";
export const BASE_IMAGE_URL = "https://image.tmdb.org/t/p/original";
export const STORAGE_KEY = "@primeflix";
